module.exports = __webpack_public_path__ + "static/img/アセット 66@3x.b0a2ed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 66@3x.png
// module id = KFcq
// module chunks = 1